import React from "react";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-neutral-200"
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-2">
            <span
              aria-hidden
              className="inline-block w-1.5 h-1.5 rounded-full"
              style={{ background: "#c9a86a" }}
            />
            <span className="font-display tracking-[0.28em] text-sm font-medium text-neutral-950">
              WEDFLOW
            </span>
          </div>
          <p className="mt-6 font-display text-[22px] md:text-[28px] leading-snug tracking-[-0.01em] font-light max-w-md text-neutral-900">
            {t.footer.tagline}
          </p>
        </div>
        <div className="md:col-span-6 grid grid-cols-2 gap-8 text-[14px] text-neutral-700">
          <div className="flex flex-col gap-3">
            <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              Esplora
            </div>
            <a href="#how" data-testid="footer-link-how" className="wf-link">
              {t.nav.how}
            </a>
            <a href="#benefits" data-testid="footer-link-benefits" className="wf-link">
              {t.nav.benefits}
            </a>
            <a href="#pricing" data-testid="footer-link-pricing" className="wf-link">
              {t.nav.pricing}
            </a>
            <a href="#faq" data-testid="footer-link-faq" className="wf-link">
              {t.nav.faq}
            </a>
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              Contatti
            </div>
            <a href="mailto:info@pec.wedflow.me" data-testid="footer-email" className="wf-link">
              info@pec.wedflow.me
            </a>
            <a href="/privacy" data-testid="footer-privacy" className="wf-link">
              Privacy Policy
            </a>
            <a href="/login" data-testid="footer-cta" className="wf-link">
              Inizia gratis
            </a>
            <a href="/partner" data-testid="footer-partner" className="wf-link">
              Diventa partner
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-neutral-200">
        <div className="max-w-[1240px] mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] tracking-[0.12em] uppercase text-neutral-500">
          <span>© {year} WEDFLOW — {t.footer.rights}</span>
          <span>{t.footer.made}</span>
        </div>
      </div>
    </footer>
  );
}
